// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/stall-speed.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/stall-speed/stall-speed-altitude.js';
import g1 from '../lessons/aeronautics/stall-speed/stall-speed-bank.js';

mount([g0, g1]);
